<template>
  <section>
    <v-dialog
      :value="isOpenDialog"
      @click:outside="closeDialog"
      max-width="550px"
    >
      <ValidationObserver v-slot="{ handleSubmit }">
        <v-card :loading="isLoading">
          <v-card-title class="pa-0 shadow-1">
            <v-img
              :src="require('@/assets/illustrations/bg_modal_card.svg')"
              cover
              position="left bottom"
              class="align-center"
              height="65px"
            >
              <v-card-title class="font-weight-medium primary--text">
                Reasignar
              </v-card-title>
            </v-img>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <ValidationProvider
                    name="agente actual"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-select
                      :disabled="isLoading"
                      v-model="payload.agent_old"
                      :items="AgentList"
                      :error-messages="errors"
                      item-text="name"
                      item-value="id"
                      prepend-inner-icon="mdi-account"
                      label="Agente actual"
                      filled
                      rounded
                      class="rounded-small"
                    >
                    </v-select>
                  </ValidationProvider>
                </v-col>

                <v-col cols="12">
                  <ValidationProvider
                    name="agente nuevo"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-select
                      :disabled="isLoading"
                      v-model="payload.agent_new"
                      :items="AgentList"
                      :error-messages="errors"
                      item-text="name"
                      item-value="id"
                      prepend-inner-icon="mdi-account"
                      label="Agente nuevo"
                      filled
                      rounded
                      class="rounded-small"
                    >
                    </v-select>
                  </ValidationProvider>
                </v-col>

                <v-col cols="12">
                  <ValidationProvider
                    name="cantidad"
                    rules="required|numeric"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      :disabled="isLoading"
                      filled
                      rounded
                      class="rounded-small"
                      label="Cantidad"
                      v-model="payload.quantity"
                      :error-messages="errors"
                      type="number"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="danger" @click="closeDialog" text rounded>
              Cancelar
            </v-btn>
            <v-btn
              :loading="isLoading"
              color="success"
              class="px-5"
              @click="openConfirm"
              large
              rounded
            >
              Reasignar
            </v-btn>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>
    <!-- Confirm -->
    <v-dialog
      :value="isOpenConfirm"
      @click:outside="closeConfirm"
      max-width="600px"
    >
      <v-card>
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              Confirmación
            </v-card-title>
          </v-img>
        </v-card-title>
        <v-card-text>
          ¿Está seguro que desea reasignar esta campaña?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="danger" @click="closeConfirm" text rounded>
            Cancelar
          </v-btn>
          <v-btn color="success" class="px-5" @click="submitForm" large rounded>
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card></v-dialog
    >
  </section>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
export default {
  props: {
    isOpenDialog: { type: Boolean, required: true },
    campaignId: { type: Number, required: true },
    oldAgent: { type: Number, required: true }
  },
  data() {
    return {
      isLoading: false,
      isOpenConfirm: false,
      payload: {
        campaign_id: Number(this.campaignId),
        agent_old: null,
        agent_new: null,
        quantity: null
      }
    };
  },

  computed: {
    AgentList() {
      return this.$store.getters["agents/GET_ALL_AGENTS"];
    }
  },

  created() {
    if (!this.AgentList.length) this.$store.dispatch("agents/GET_ALL_AGENTS");
  },

  methods: {
    closeDialog() {
      this.$emit("dialog:close");
    },
    async submitForm() {
      this.closeConfirm();
      this.isLoading = true;
      try {
        await PbxHttpClient.post(`/campaign/pass_agent_logs`, this.payload);
        this.$snotify.success("Campaña reasignada con éxito.", "¡Hecho!");
        this.closeDialog();
      } catch (error) {
        // console.log(error);
        this.$snotify.error("Hubo un error reasignando la campaña.", "¡Error!");
      }
      this.isLoading = false;
    },

    openConfirm() {
      this.isOpenConfirm = true;
    },
    closeConfirm() {
      this.isOpenConfirm = false;
    }
  }
};
</script>

<style></style>
